export default __webpack_public_path__ + "static/media/ic-unattempted-result.bb5aa46e.svg";